/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".custom-container[_ngcontent-%COMP%]{width:100%;margin-right:auto;margin-left:auto}.btn-size[_ngcontent-%COMP%]{width:150px!important;height:36px!important}.mat-spinner[_ngcontent-%COMP%]   circle[_ngcontent-%COMP%], .spinner-wht[_ngcontent-%COMP%]     .mat-progress-spinner circle{stroke:#fff!important}"];
export { styles as styles };
